import { render, staticRenderFns } from "./RowBlockWithdrawInvoiceForPartnerByMainUser.vue?vue&type=template&id=70bc83ac&"
import script from "./RowBlockWithdrawInvoiceForPartnerByMainUser.vue?vue&type=script&lang=js&"
export * from "./RowBlockWithdrawInvoiceForPartnerByMainUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports